import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getHostAndHostessMasterList_action, insertUpdateHostAndHostessMaster_action, deleteHostAndHostessMaster_action } from "../../../../../actions/admin_module_action/master_action/manual_form_master_action/host_and_hostess_master_action";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import { emailValidator } from "../../../../../utils/Validator";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";


class HostAndHostessMaster extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            status: '',
            editID: null,
            // Agency Contact fields
            Name: '',
            Address: '',
            Phone: '',
            Mobile: '',
            Fax: '',
            PrimaryEmail: '',
            SecondaryEmail: '',
            // Bank Detail fields
            BankName: '',
            BankAddress: '',
            BeneficiaryName: '',
            BeneficiaryAddress: '',
            AccountNumber: '',
            SwiftCode: '',
            IFSCCode: '',
            PAN: '',
            GST: '',
            // Rate fields
            HostRateINR: '',
            HostRateUSD: '',
            HostessRateINR: '',
            HostessRateUSD: '',
            // Validation errors - Contact/Bank
            NameErr: '',
            AddressErr: '',
            MobileErr: '',
            PrimaryEmailErr: '',
            SecondaryEmailErr: '',
            BankNameErr: '',
            BankAddressErr: '',
            BeneficiaryNameErr: '',
            BeneficiaryAddressErr: '',
            AccountNumberErr: '',
            SwiftCodeErr: '',
            IFSCCodeErr: '',
            PANErr: '',
            GSTErr: '',
            // Validation errors - Rates
            HostRateINRErr: '',
            HostRateUSDErr: '',
            HostessRateINRErr: '',
            HostessRateUSDErr: '',
            // List
            HostAndHostessContactList: [],
            index: 1,
        }
        this.OnCancel = this.OnCancel.bind(this)
        this.inputValidateContact = this.inputValidateContact.bind(this)
        this.inputValidateRates = this.inputValidateRates.bind(this)
        this.renderHostAndHostessContactList = this.renderHostAndHostessContactList.bind(this)
        this.handleAddMoreContact = this.handleAddMoreContact.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.ClearValue = this.ClearValue.bind(this)
    }

    componentDidMount() {
        const locState = this.props.location.state
        const editData = locState && locState.editData ? locState.editData : null
        this.setState({
            status: locState && locState.status ? locState.status : '',
            ...(editData ? {
                Name: editData.Name || '', Address: editData.Address || '',
                Phone: editData.Phone || '', Mobile: editData.Mobile || '',
                Fax: editData.Fax || '', PrimaryEmail: editData.PrimaryEmail || '',
                SecondaryEmail: editData.SecondaryEmail || '',
                BankName: editData.BankName || '', BankAddress: editData.BankAddress || '',
                BeneficiaryName: editData.BeneficiaryName || '', BeneficiaryAddress: editData.BeneficiaryAddress || '',
                AccountNumber: editData.AccountNumber || '', SwiftCode: editData.SwiftCode || '',
                IFSCCode: editData.IFSCCode || '', PAN: editData.PAN || '', GST: editData.GST || '',
                editID: editData.MstHostAndHostessContactBankID || null,
            } : {}),
        })
        this.getHostAndHostessMasterList(editData ? editData.MstHostAndHostessContactBankID : null)
    }

    OnCancel() {
        this.props.navigate('/hostAndHostessMasterList')
    }

    getHostAndHostessMasterList(editID) {
        this.setState({ isLoading: true })
        this.props.getHostAndHostessMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    const rate = data.data.rates && data.data.rates.length > 0 ? data.data.rates[0] : null
                    if (rate) {
                        this.setState({
                            HostRateINR: rate.HostRateINR != null ? rate.HostRateINR : '',
                            HostRateUSD: rate.HostRateUSD != null ? rate.HostRateUSD : '',
                            HostessRateINR: rate.HostessRateINR != null ? rate.HostessRateINR : '',
                            HostessRateUSD: rate.HostessRateUSD != null ? rate.HostessRateUSD : '',
                        })
                    }
                    let contactList = data.data.contactBankList ? data.data.contactBankList : []
                    if (editID) {
                        contactList = contactList.filter(r => r.MstHostAndHostessContactBankID !== editID)
                    }
                    contactList = contactList.map((r, i) => ({ ...r, isShow: true, index: i + 1 }))
                    this.setState({
                        HostAndHostessContactList: contactList,
                        index: contactList.length + 1,
                        isLoading: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    inputValidateContact() {
        const { Name, Address, Mobile, PrimaryEmail, SecondaryEmail } = this.state
        if (Name == '') { this.setState({ NameErr: 'Please Enter Name' }) }
        if (Mobile == '') { this.setState({ MobileErr: 'Please Enter Mobile No.' }) }
        if (PrimaryEmail == '') {
            this.setState({ PrimaryEmailErr: 'Please Enter Primary Email' })
        } else {
            const PEmailerr = (emailValidator(PrimaryEmail) == '') ? false : emailValidator(PrimaryEmail)
            if (PEmailerr) { this.setState({ PrimaryEmailErr: 'Please Enter Proper Primary Email' }) }
        }
        if (SecondaryEmail != '' && SecondaryEmail != null) {
            const SEmailerr = (emailValidator(SecondaryEmail) == '') ? false : emailValidator(SecondaryEmail)
            if (SEmailerr) { this.setState({ SecondaryEmailErr: 'Please Enter Proper Secondary Email' }) }
        }
    }

    inputValidateRates() {
        const { HostRateINR, HostRateUSD, HostessRateINR, HostessRateUSD } = this.state
        let valid = true
        if (HostRateINR === '' || HostRateINR === null) { this.setState({ HostRateINRErr: 'Please Enter Host Rate (INR)' }); valid = false }
        if (HostRateUSD === '' || HostRateUSD === null) { this.setState({ HostRateUSDErr: 'Please Enter Host Rate (USD)' }); valid = false }
        if (HostessRateINR === '' || HostessRateINR === null) { this.setState({ HostessRateINRErr: 'Please Enter Hostess Rate (INR)' }); valid = false }
        if (HostessRateUSD === '' || HostessRateUSD === null) { this.setState({ HostessRateUSDErr: 'Please Enter Hostess Rate (USD)' }); valid = false }
        return valid
    }

    renderHostAndHostessContactList() {
        const { HostAndHostessContactList } = this.state
        return (
            <ul class="list-group" style={{ position: 'relative', zIndex: 1 }}>
                {
                    HostAndHostessContactList.length > 0 && HostAndHostessContactList.map((data, index) => (
                        data.isShow &&
                        <li class="list-group-item" key={Math.random()}>
                            <div className="added-more p-3 rounded-2">
                                <h5 style={{ color: '#0056ff' }}>Added Host and Hostess Master {data.index}</h5>
                                <h6>Agency Contact</h6>
                                <div className="row mt-4">
                                    <div className="col-md-3"><h6>Name: {data.Name}</h6></div>
                                    <div className="col-md-3"><h6>Mobile no.: {data.Mobile}</h6></div>
                                    <div className="col-md-6"><h6>Address: {data.Address}</h6></div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3"><h6>Telephone: {data.Phone}</h6></div>
                                    <div className="col-md-3"><h6>Fax: {data.Fax}</h6></div>
                                    <div className="col-md-3"><h6>Primary Email: {data.PrimaryEmail}</h6></div>
                                    <div className="col-md-3"><h6>Secondary Email: {data.SecondaryEmail}</h6></div>
                                </div>
                            </div>
                            <hr className="m-1" />
                            <div className="added-more p-3 rounded-2">
                                <h6>Bank Details</h6>
                                <div className="row mt-4">
                                    <div className="col-md-3"><h6>Bank Name: {data.BankName}</h6></div>
                                    <div className="col-md-6"><h6>Bank Address: {data.BankAddress}</h6></div>
                                    <div className="col-md-3"><h6>Account Number: {data.AccountNumber}</h6></div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3"><h6>Beneficiary Name: {data.BeneficiaryName}</h6></div>
                                    <div className="col-md-6"><h6>Beneficiary Address: {data.BeneficiaryAddress}</h6></div>
                                    <div className="col-md-3"><h6>Swift Code: {data.SwiftCode}</h6></div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3"><h6>IFSC Code: {data.IFSCCode}</h6></div>
                                    <div className="col-md-3"><h6>PAN Number: {data.PAN}</h6></div>
                                    <div className="col-md-3"><h6>GST Number: {data.GST}</h6></div>
                                </div>
                            </div>
                        </li>
                    ))
                }
            </ul>
        )
    }

    handleAddMoreContact() {
        const {
            BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
            AccountNumber, SwiftCode, IFSCCode, PAN, GST,
            Name, Address, Mobile, PrimaryEmail, SecondaryEmail,
            NameErr, AddressErr, MobileErr, PrimaryEmailErr, SecondaryEmailErr,
            HostAndHostessContactList, index, Phone, Fax,
        } = this.state
        this.inputValidateContact()
        if (Name != '' && Mobile != '' && PrimaryEmail != '') {
            if (NameErr == '' && MobileErr == '' && PrimaryEmailErr == '' && SecondaryEmailErr == '') {
                HostAndHostessContactList.push({
                    BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
                    AccountNumber, SwiftCode, IFSCCode, PAN, GST,
                    Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail,
                    isShow: true, index,
                })
                setTimeout(() => { this.ClearValue() }, 200)
            } else {
                toastError('Please enter proper fields')
            }
        } else {
            toastError('Please enter mandatory fields')
        }
    }

    handleSave() {
        const { status, HostAndHostessContactList, editID,
            Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail,
            BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
            AccountNumber, SwiftCode, IFSCCode, PAN, GST,
            HostRateINR, HostRateUSD, HostessRateINR, HostessRateUSD,
        } = this.state

        if (status == 1) {
            this.inputValidateContact()
            if (!Name || !Mobile || !PrimaryEmail) {
                toastError('Please enter mandatory fields')
                return
            }
            const { HostAndHostessContactList } = this.state
            const existingList = HostAndHostessContactList.filter(r => r.isShow).map(r => ({
                Name: r.Name, Address: r.Address, Phone: r.Phone, Mobile: r.Mobile, Fax: r.Fax,
                PrimaryEmail: r.PrimaryEmail, SecondaryEmail: r.SecondaryEmail,
                BankName: r.BankName, BankAddress: r.BankAddress, BeneficiaryName: r.BeneficiaryName,
                BeneficiaryAddress: r.BeneficiaryAddress, AccountNumber: r.AccountNumber,
                SwiftCode: r.SwiftCode, IFSCCode: r.IFSCCode, PAN: r.PAN, GST: r.GST,
                MstHostAndHostessContactBankID: r.MstHostAndHostessContactBankID || null,
            }))
            const contactList = [
                ...existingList,
                {
                    Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail,
                    BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
                    AccountNumber, SwiftCode, IFSCCode, PAN, GST,
                    ...(editID ? { MstHostAndHostessContactBankID: editID } : {}),
                },
            ]
            this.setState({ isLoading: true })
            this.props.insertUpdateHostAndHostessMaster_action(
                parseFloat(HostRateINR) || null, parseFloat(HostRateUSD) || null,
                parseFloat(HostessRateINR) || null, parseFloat(HostessRateUSD) || null,
                contactList
            )
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess('Record Added Successfully')
                        setTimeout(() => {
                            this.setState({ isLoading: false })
                            this.props.navigate('/hostAndHostessMasterList')
                        }, 300)
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
        } else if (status == 2) {
            if (!this.inputValidateRates()) return
            this.setState({ isLoading: true })
            this.props.insertUpdateHostAndHostessMaster_action(
                parseFloat(HostRateINR), parseFloat(HostRateUSD),
                parseFloat(HostessRateINR), parseFloat(HostessRateUSD),
                []
            )
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess('Record Added Successfully')
                        setTimeout(() => {
                            this.setState({ isLoading: false })
                            this.props.navigate('/hostAndHostessMasterList')
                        }, 300)
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => { console.log(err); this.setState({ isLoading: false }) })
        }
    }

    ClearValue() {
        this.setState({
            BankName: '', BankAddress: '', BeneficiaryName: '', BeneficiaryAddress: '',
            AccountNumber: '', SwiftCode: '', IFSCCode: '', PAN: '', GST: '',
            Name: '', Address: '', Phone: '', Mobile: '', Fax: '', PrimaryEmail: '', SecondaryEmail: '',
            index: this.state.index + 1,
        })
    }

    render() {
        const {
            isLoading, status, editID,
            Name, Address, Phone, Mobile, Fax, PrimaryEmail, SecondaryEmail,
            BankName, BankAddress, BeneficiaryName, BeneficiaryAddress,
            AccountNumber, SwiftCode, IFSCCode, PAN, GST,
            HostRateINR, HostRateUSD, HostessRateINR, HostessRateUSD,
            NameErr, AddressErr, MobileErr, PrimaryEmailErr, SecondaryEmailErr,
            BankNameErr, BankAddressErr, BeneficiaryNameErr, BeneficiaryAddressErr,
            AccountNumberErr, SwiftCodeErr, IFSCCodeErr, PANErr, GSTErr,
            HostRateINRErr, HostRateUSDErr, HostessRateINRErr, HostessRateUSDErr,
        } = this.state
        return (
            <>
                {isLoading ? <Loader /> : null}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <p className="mb-0 p-2 text-white">Host and Hostess Master</p>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 pt-0">

                                {/* ── Status 1: Agency Contact + Bank Details ── */}
                                {status == 1 && <div className="">
                                    <div className="">
                                        <div className="card-header p-2" style={{ paddingLeft: '7px !important' }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>Agency Contact</h3>
                                        </div>
                                        <div className="card-body p-2 mt-1">
                                            <div className="row">
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Name<span className="text-red">*</span></label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={Name} onChange={(e) => this.setState({ Name: e.target.value, NameErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{NameErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Mobile No.<span className="text-red">*</span></label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        placeholder="Use / to separate multiple numbers"
                                                        value={Mobile} onChange={(e) => this.setState({ Mobile: e.target.value, MobileErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{MobileErr}</span>}
                                                </div>
                                                <div className="col-xl-6">
                                                    <label htmlFor="validationCustom03">Address</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={Address} onChange={(e) => this.setState({ Address: e.target.value, AddressErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{AddressErr}</span>}
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Telephone</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        placeholder="Use / to separate multiple numbers"
                                                        value={Phone} onChange={(e) => this.setState({ Phone: e.target.value })} />
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Fax</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        placeholder="Use / to separate multiple numbers"
                                                        value={Fax} onChange={(e) => this.setState({ Fax: e.target.value })} />
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Primary Email<span className="text-red">*</span></label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={PrimaryEmail} onChange={(e) => this.setState({ PrimaryEmail: e.target.value, PrimaryEmailErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{PrimaryEmailErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Secondary Email</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={SecondaryEmail} onChange={(e) => this.setState({ SecondaryEmail: e.target.value, SecondaryEmailErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{SecondaryEmailErr}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="card-header p-2" style={{ paddingLeft: '7px !important' }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>Bank Details</h3>
                                        </div>
                                        <div className="card-body p-2 mt-1">
                                            <div className="row">
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Bank Name</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={BankName} onChange={(e) => this.setState({ BankName: e.target.value, BankNameErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{BankNameErr}</span>}
                                                </div>
                                                <div className="col-xl-6">
                                                    <label htmlFor="validationCustom03">Bank Address</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={BankAddress} onChange={(e) => this.setState({ BankAddress: e.target.value, BankAddressErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{BankAddressErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Account Number</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={AccountNumber} onChange={(e) => this.setState({ AccountNumber: e.target.value, AccountNumberErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{AccountNumberErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Beneficiary Name</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={BeneficiaryName} onChange={(e) => this.setState({ BeneficiaryName: e.target.value, BeneficiaryNameErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{BeneficiaryNameErr}</span>}
                                                </div>
                                                <div className="col-xl-6">
                                                    <label htmlFor="validationCustom03">Beneficiary Address</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={BeneficiaryAddress} onChange={(e) => this.setState({ BeneficiaryAddress: e.target.value, BeneficiaryAddressErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{BeneficiaryAddressErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Swift Code</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={SwiftCode} onChange={(e) => this.setState({ SwiftCode: e.target.value, SwiftCodeErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{SwiftCodeErr}</span>}
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">IFSC Code</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={IFSCCode} onChange={(e) => this.setState({ IFSCCode: e.target.value, IFSCCodeErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{IFSCCodeErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">PAN Number</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={PAN} onChange={(e) => this.setState({ PAN: e.target.value, PANErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{PANErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">GST Number</label>
                                                    <input type="text" className="form-control" id="validationCustom03" required=""
                                                        value={GST} onChange={(e) => this.setState({ GST: e.target.value, GSTErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{GSTErr}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>}

                                {/* ── Status 2: Rate Configuration ── */}
                                {status == 2 && <div className="">
                                    <div className="">
                                        <div className="card-header p-2" style={{ paddingLeft: '7px !important' }}>
                                            <h3 className="card-title" style={{ fontSize: 15 }}>Rate Configuration</h3>
                                        </div>
                                        <div className="card-body p-2 mt-1">
                                            <div className="row">
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Host Rate per Day (INR)<span className="text-red">*</span></label>
                                                    <input type="number" className="form-control" id="validationCustom03" required=""
                                                        value={HostRateINR} onChange={(e) => this.setState({ HostRateINR: e.target.value, HostRateINRErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{HostRateINRErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Host Rate per Day (USD)<span className="text-red">*</span></label>
                                                    <input type="number" className="form-control" id="validationCustom03" required=""
                                                        value={HostRateUSD} onChange={(e) => this.setState({ HostRateUSD: e.target.value, HostRateUSDErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{HostRateUSDErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Hostess Rate per Day (INR)<span className="text-red">*</span></label>
                                                    <input type="number" className="form-control" id="validationCustom03" required=""
                                                        value={HostessRateINR} onChange={(e) => this.setState({ HostessRateINR: e.target.value, HostessRateINRErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{HostessRateINRErr}</span>}
                                                </div>
                                                <div className="col-xl-3">
                                                    <label htmlFor="validationCustom03">Hostess Rate per Day (USD)<span className="text-red">*</span></label>
                                                    <input type="number" className="form-control" id="validationCustom03" required=""
                                                        value={HostessRateUSD} onChange={(e) => this.setState({ HostessRateUSD: e.target.value, HostessRateUSDErr: '' })} />
                                                    {<span className='text-danger text-start text-left d-block mt-1'>{HostessRateUSDErr}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {/* ── Save + Back ── */}
                                <div className="row">
                                    <div className="mt-2 save-can d-block" role="group" style={{ float: 'right' }} aria-label="Basic example">
                                        <button type="button" className="btn btn-aqua"
                                            onClick={() => this.handleSave()}>
                                            Save
                                        </button>
                                        <button type="button" className="btn btn-back"
                                            onClick={() => this.OnCancel()}>
                                            Back
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            </>
        )
    }
}

export default withRouter(connect(null, { getHostAndHostessMasterList_action, insertUpdateHostAndHostessMaster_action, deleteHostAndHostessMaster_action })(HostAndHostessMaster))
